module.exports = __webpack_public_path__ + "static/media/MachineTests.780d9aef.jpg";